"use strict";

var _classCallCheck = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var toposort = require("toposort");

var LocalContextPlugin =
/*#__PURE__*/
function () {
  function LocalContextPlugin(transcriber) {
    _classCallCheck(this, LocalContextPlugin);

    this.m_Transcriber = transcriber;
  }

  _createClass(LocalContextPlugin, [{
    key: "Transcribe",
    value: function Transcribe() {
      var _this = this;

      var to_transcribe = this.GetContextList();
      to_transcribe.forEach(function (name) {
        var context = _this.m_Transcriber.GetLocalContext(name);

        context.m_Refs.forEach(function (path) {
          return path.findParent(function (path) {
            return path.isExpressionStatement();
          }).replaceWithMultiple(context.ToStatements());
        });
      });
    }
  }, {
    key: "GetContextList",
    value: function GetContextList() {
      var _this2 = this;

      var graph = [];
      this.m_Transcriber.TraverseLocalContext(function (context, name) {
        context.m_Refs.forEach(function (path) {
          var parent = path.findParent(function (path) {
            return path.isFunctionDeclaration() || path.isFunctionExpression() || path.isExportDeclaration();
          });

          if (parent) {
            graph.push([name, parent.node.id.name]);
          }
        });
      });
      var context_list = toposort(graph).filter(function (name) {
        return _this2.m_Transcriber.GetLocalContext(name);
      });
      return context_list;
    }
  }]);

  return LocalContextPlugin;
}();

exports.LocalContextPlugin = LocalContextPlugin;

var ILocalContextPlugin = function ILocalContextPlugin() {
  _classCallCheck(this, ILocalContextPlugin);
};

exports.ILocalContextPlugin = ILocalContextPlugin;